import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function RightSideOfRoof() {
  return <PhotoLayout {...photoLayoutConfig['roofRight']} />;
}
